export default "__VITE_ASSET__BC5d4mld__"